/*@ngInject*/
module.exports = function () {
    return {
        scope: {
            objectGisIds: '=',
            routeGisIds: '=',
        },
        restrict: 'E',
        replace: true,
        template: require('./bookmarks-map.directive.html'),
        require: 'ngModel',
        controllerAs: 'vm',
        bindToController: true,
        /*@ngInject*/
        controller: function ($sce, publicRoutesService, publicObjectsService, mapService, $scope, $rootScope, $uibModal) {
            let vm = this;
            vm.url = '';
            vm.mapSource = '';
            vm.mapUrlsLoaded = false;

            vm.objectUrl = '';
            vm.roadElementPathUrl = '';
            vm.roadElementObstacleUrl = '';
            vm.routeUrl = '';
            vm.rootscope = $rootScope;

            vm.$onInit = function() {
                const mapUrls = vm.rootscope.mapUrls;

                vm.objectUrl = mapUrls.objectUrl;
                vm.roadElementPathUrl = mapUrls.roadElementPathUrl;
                vm.roadElementObstacleUrl = mapUrls.roadElementObstacleUrl;
                vm.routeUrl = mapUrls.routeUrl;
                vm.busStopUrl = mapUrls.busStopUrl;
                vm.akisUrl = mapUrls.akisUrl;
                vm.opisUrl = mapUrls.opisUrl;
                vm.mapSource = mapUrls.mapUrl;

                let hideUrls = vm.roadElementObstacleUrl + ',' + vm.roadElementPathUrl;
                vm.url = $sce.trustAsResourceUrl(vm.mapSource + '?init=[{"type":"filter","ids":[], "url":' + JSON.stringify(vm.objectUrl) + ', "zoomTo":true},{"type":"filter","ids":[], "url":'+ JSON.stringify(vm.routeUrl) + ', "zoomTo":true},{"type":"hide-layers","url":' + JSON.stringify(hideUrls)+ '}]');

                vm.mapUrlsLoaded = true;
            };


            const unsub = mapService.subscribe(data => {
                if (data.type === 'ready') {
                    vm.mapLoaded = true;
                    if (vm.routeGisIds) {
                        vm.postFilter(vm.routeGisIds, vm.routeUrl);
                        vm.postFilter(vm.objectGisIds, vm.objectUrl);
                        vm.enableIdentify();
                    }
                }

                if (data.url && data.type === 'identify-result' && !data.cluster) {
                    if (data.url.includes(vm.opisUrl) || data.url.includes(vm.akisUrl)) {
                        vm.rootscope.openAkisOpisModal(data);
                    } else if (data.url === vm.routeUrl && vm.routeGisIds) {
                        angular.forEach(vm.routeGisIds, function (gisId) {
                            if (gisId === data.id) {
                                vm.openRouteModal(data.id);
                            }
                        });
                    } else if (data.url === vm.objectUrl || data.url === vm.busStopUrl) {
                        vm.openObjectModal(data.id);
                    }
                }
            });

            vm.openRouteModal = (identifyResultRouteId) => {
                publicRoutesService.getRouteDataByGisId(identifyResultRouteId).then((result) => {
                    if (result.data !== 'string') {
                        $uibModal.open({
                            template: require('../routes/search_directives/route-data-modal.html'),
                            controller: require('../routes/search_directives/route-data-modal.directive'),
                            controllerAs: 'vm',
                            size: 'lg',
                            backdrop: 'static',
                            keyboard: false,
                            windowClass: 'center-modal',
                            resolve: {
                                data () {
                                    return result.data ;
                                }
                            }
                        });
                        $rootScope.isModalOpen = true;
                    }
                });
            };

            vm.openObjectModal = (identifyResultObjectId) => {
                publicObjectsService.getObjectDataByGisId(identifyResultObjectId).then((result) => {
                    if (result.data !== 'string') {
                        vm.selectedObject = result.data;
                        $uibModal.open({
                            template: require('../object-data-modal.html'),
                            controller: require('../object-data-modal.directive'),
                            controllerAs: 'vm',
                            size: 'lg',
                            backdrop: 'static',
                            keyboard: false,
                            windowClass: 'center-modal',
                            resolve: {
                                object () {
                                    return result.data ;
                                }
                            }
                        });
                        $rootScope.isModalOpen = true;
                    }
                });
            };

            $scope.$on('$destroy', () => unsub());

            vm.postFilter = function (ids, url) {
                vm.postMessage({type: 'filter', ids: ids, url: url});
            };

            vm.enableIdentify = function() {
                vm.postMessage({type: 'enable-identify', url: `${ vm.routeUrl },${ vm.objectUrl },${ vm.busStopUrl },${ vm.akisUrl },${ vm.opisUrl }`});
            };

            vm.postMessage = (message) => {
                return document.getElementById('map').contentWindow.postMessage(message, vm.mapSource);
            };

        }
    };
};



/** WEBPACK FOOTER **
 ** ./app/shared/directives/bookmarks/bookmarks-map.directive.js
 **/